"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VideoArea = exports.Title = exports.StyledTextWithHtml = exports.Root = exports.Inner = exports.Description = exports.ContentArea = exports.Caption = exports.Button = void 0;
var _mui = require("@ori-ui/mui");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _shared = require("../shared");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)([
        'backgroundColor'
    ])
})((param)=>{
    let { backgroundColor, theme } = param;
    return {
        background: backgroundColor,
        padding: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(8)
        }
    };
});
const Caption = exports.Caption = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.text.primary,
        textTransform: 'uppercase',
        fontWeight: theme.typography.fontWeightBold,
        letterSpacing: '2.4px',
        fontSize: '1.2rem',
        display: '-webkit-box',
        WebkitLineClamp: 1,
        lineClamp: 1,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden'
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4, 0),
        [theme.breakpoints.up('md')]: {
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 auto',
            gap: theme.spacing(0, 8),
            flexDirection: 'row'
        }
    };
});
const VideoArea = exports.VideoArea = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, alignment } = param;
    return {
        margin: '0 auto',
        maxWidth: 330,
        minWidth: 250,
        order: alignment === _editorialFetching.HorizontalContentAlignment.Right || alignment === _editorialFetching.HorizontalContentAlignment.Undefined ? 1 : 0,
        width: '100%',
        [".".concat(_shared.videoLayoutClasses.externalRoot)]: {
            iframe: {
                aspectRatio: '9 / 16'
            }
        },
        [theme.breakpoints.up('md')]: {
            display: 'block',
            alignSelf: 'center',
            margin: 0
        }
    };
});
const ContentArea = exports.ContentArea = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        order: 2,
        flexDirection: 'column',
        width: '100%',
        maxWidth: 'unset',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            order: 'unset',
            maxWidth: 600
        }
    };
});
const Title = exports.Title = (0, _mui.styled)(_shared.Title)((param)=>{
    let { theme } = param;
    return {
        margin: 0,
        textAlign: 'left',
        [theme.breakpoints.up('md')]: {
            marginBottom: theme.spacing(1)
        }
    };
});
const Description = exports.Description = (0, _mui.styled)('div')({
    maxHeight: 320,
    overflow: 'hidden'
});
const StyledTextWithHtml = exports.StyledTextWithHtml = (0, _mui.styled)(_presentationComponents.TextWithHtml)({
    fontSize: '1.4rem'
});
const Button = exports.Button = (0, _mui.styled)(_shared.Button)((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginTop: theme.spacing(4)
        }
    };
});
